import { render, staticRenderFns } from "./PartnerClientListLayout.vue?vue&type=template&id=7bc17450&"
import script from "./PartnerClientListLayout.vue?vue&type=script&lang=ts&"
export * from "./PartnerClientListLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports